<template>
    <div class="upload-container">
        <div class="message">
            Found {{ uploads.length }} upload{{ uploads.length == 1 ? '' : 's' }}
        </div>
        <div v-if="uploads.length > 0" class="uploads">
            <div v-for="upload of uploads" v-bind:key="upload.id">
                <div class="uploaded-file mt-1">
                    <div class="d-flex justify-content-between mb-1">
                        <span class="text-truncate">{{ upload.file_name }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss">
.title {
    display: flex;
    gap: 1rem;
    justify-items: center;
}
.uploads-loading {
    color: $swift-fresh-green;
}
</style>
<script>
import api from '@/services/api';

export default {
    props: {
        token: {
            required: true,
        },
        onQrUploads: {
            default: [],
        },
    },
    emits: ['addQrUpload'],
    data() {
        return {
            uploads: [],
            message: null,
            interval: null,
        };
    },
    methods: {
        getUploads: async function () {
            try {
                const res = await api.get('/api/v1/qr/getUploads', {
                    params: {
                        token: this.token,
                    },
                });
                this.uploads = res.data.uploads;
                this.message = 'Found ' + this.uploads.length + ' upload/s'
                this.$emit('qrUploads', res.data.uploads);
            } catch (e) {
                this.message = e.message;
            }
        },
    },
    async mounted() {
        await this.getUploads();
        this.interval = setInterval(this.getUploads, 10000);
    },
    beforeUnmount() {
        clearInterval(this.interval);
    }
}
</script>